import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="android" api="extension-version" repeat="8" mdxType="Variant" />
    <h4 {...{
      "id": "java"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`@NonNull public static String extensionVersion()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`String extensionVersion = UserProfile.extensionVersion();
`}</code></pre>
    <h4 {...{
      "id": "kotlin"
    }}>{`Kotlin`}</h4>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`val extensionVersion = UserProfile.extensionVersion();
`}</code></pre>
    <Variant platform="ios" api="extension-version" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static var extensionVersion: String
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let extensionVersion = UserProfile.extensionVersion
`}</code></pre>
    <h4 {...{
      "id": "objective-c"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (nonnull NSString*) extensionVersion;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`NSString *extensionVersion = [AEPMobileUserProfile extensionVersion];
`}</code></pre>
    <Variant platform="android" api="get-user-attributes" repeat="13" mdxType="Variant" />
    <h4 {...{
      "id": "java-1"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void getUserAttributes(@NonNull final List<String> keys, @NonNull final AdobeCallback<Map<String, Object>> callback)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is invoked after the customer attributes are available.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <p>{`A retail application wants to get the `}<inlineCode parentName="p">{`itemsAddedToCart`}</inlineCode>{` user data when processing checkout.`}</p>
    <p>{`When `}<inlineCode parentName="p">{`AdobeCallbackWithError`}</inlineCode>{` is provided, if the operation times out (5s) or an unexpected error occurs, the `}<inlineCode parentName="p">{`fail`}</inlineCode>{` method is called with the appropriate `}<inlineCode parentName="p">{`AdobeError`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`UserProfile.getUserAttributes(Arrays.asList("itemsAddedToCart"), new AdobeCallbackWithError<Map<String, Object>>() {
    @Override
    public void fail(AdobeError adobeError) {
         // your customized code
    }
    @Override
    public void call(Map<String, Object> stringObjectMap) {
        // your customized code
    }
});
`}</code></pre>
    <h4 {...{
      "id": "kotlin-1"
    }}>{`Kotlin`}</h4>
    <p><strong parentName="p">{`Example`}</strong></p>
    <p>{`A retail application wants to get the `}<inlineCode parentName="p">{`itemsAddedToCart`}</inlineCode>{` user data when processing checkout.`}</p>
    <p>{`When `}<inlineCode parentName="p">{`AdobeCallbackWithError`}</inlineCode>{` is provided, if the operation times out (5s) or an unexpected error occurs, the `}<inlineCode parentName="p">{`fail`}</inlineCode>{` method is called with the appropriate `}<inlineCode parentName="p">{`AdobeError`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`UserProfile.getUserAttributes(listOf("itemsAddedToCart")) {
    object : AdobeCallbackWithError<Map<String, Any?>> {
        override fun fail(adobeError: AdobeError) {
            // your customized code
        }

        override fun call(value: Map<String, Any?>) {
            // your customized code
        }
    }
}
`}</code></pre>
    <Variant platform="ios" api="get-user-attributes" repeat="13" mdxType="Variant" />
    <h4 {...{
      "id": "swift-1"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func getUserAttributes(attributeNames: [String], completion: @escaping ([String: Any]?, AEPError) -> Void)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`completion`}</em>{` is the callback `}<inlineCode parentName="li">{`function`}</inlineCode>{` which will be called with user attributes.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <p>{`A retail application wants to get the `}<inlineCode parentName="p">{`itemsAddedToCart`}</inlineCode>{` user data when processing checkout.`}</p>
    <p>{`When the callback is provided, if the operation times out (5s) or an unexpected error occurs, the `}<inlineCode parentName="p">{`completion`}</inlineCode>{` method is called with the appropriate `}<inlineCode parentName="p">{`AEPError`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`UserProfile.getUserAttributes(attributeNames: ["itemsAddedToCart"]) { attributes, error in
// your customized code
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-1"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (void)getUserAttributesWithAttributeNames:(NSArray<NSString *> * _Nonnull) comletion:^(NSDictionary<NSString *,id> * _Nullable, enum AEPError)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`NSArray *attributes = @[@"itemsAddedToCart"];
[AEPMobileUserProfile getUserAttributesWithAttributeNames:attributes completion:^(NSDictionary<NSString *,id> * _Nullable, enum AEPError) {
        // your customized code
}];
`}</code></pre>
    <Variant platform="android" api="register-extension" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-2"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`@Deprecated
public static void registerExtension()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`import com.adobe.marketing.mobile.UserProfile

...

UserProfile.registerExtension();
`}</code></pre>
    <Variant platform="ios" api="register-extension" repeat="11" mdxType="Variant" />
    <p>{`On iOS, the registration occurs by passing UserProfile extension to the `}<a parentName="p" {...{
        "href": "../mobile-core/api-reference.md#registerextension-s"
      }}>{`MobileCore.registerExtensions API`}</a>{`.`}</p>
    <h4 {...{
      "id": "swift-2"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func registerExtensions(_ extensions: [NSObject.Type],
                               _ completion: (() -> Void)? = nil)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`import AEPUserProfile

func application(_ application: UIApplication, didFinishLaunchingWithOptions launchOptions: [UIApplication.LaunchOptionsKey: Any]?) -> Bool {

  MobileCore.registerExtensions([UserProfile.self])
  // Override point for customization after application launch.
  return true;
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-2"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (void) registerExtensions: (NSArray<Class*>* _Nonnull) extensions
                 completion: (void (^ _Nullable)(void)) completion;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`@import AEPUserProfile;

- (BOOL)application:(UIApplication *)application didFinishLaunchingWithOptions:(NSDictionary *)launchOptions {

  [AEPMobileCore registerExtensions:@[AEPMobileUserProfile.class] completion:nil];
  // Override point for customization after application launch.
  return YES;
}
`}</code></pre>
    <Variant platform="android" api="remove-user-attribute" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "java-3"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`@Deprecated
public static void removeUserAttribute(@NonNull final String attributeName)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <p>{`A retail application wants to remove the `}<inlineCode parentName="p">{`itemsAddedToCart`}</inlineCode>{` user data after the product is purchased.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`UserProfile.removeUserAttribute("itemsAddedToCart");
`}</code></pre>
    <Variant platform="android" api="remove-user-attributes" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "java-4"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void removeUserAttributes(@NonNull final List<String> attributeNames)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <p>{`You want to remove `}<inlineCode parentName="p">{`username`}</inlineCode>{`, `}<inlineCode parentName="p">{`usertype`}</inlineCode>{` user data when session timeout occurs.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`UserProfile.removeUserAttributes(Arrays.asList("username", "usertype"));
`}</code></pre>
    <h4 {...{
      "id": "kotlin-2"
    }}>{`Kotlin`}</h4>
    <p><strong parentName="p">{`Example`}</strong></p>
    <p>{`You want to remove `}<inlineCode parentName="p">{`username`}</inlineCode>{`, `}<inlineCode parentName="p">{`usertype`}</inlineCode>{` user data when session timeout occurs.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`UserProfile.removeUserAttributes(listOf("username", "usertype"))
`}</code></pre>
    <Variant platform="ios" api="remove-user-attributes" repeat="11" mdxType="Variant" />
    <h4 {...{
      "id": "swift-3"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static void removeUserAttributes(List<String> attributeNames)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <p>{`You want to remove `}<inlineCode parentName="p">{`username`}</inlineCode>{`, `}<inlineCode parentName="p">{`usertype`}</inlineCode>{` user data when session timeout occurs.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`UserProfile.removeUserAttributes(Arrays.asList("username", "usertype"));
`}</code></pre>
    <h4 {...{
      "id": "objective-c-3"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (void) removeUserAttributesWithAttributeNames:(NSArray<NSString *> * _Nonnull)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[AEPMobileUserProfile removeUserAttributesWithAttributeNames:@[@"username", @"usertype"]]
`}</code></pre>
    <Variant platform="android" api="update-user-attribute" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "java-5"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`@Deprecated
public static void updateUserAttribute(@NonNull final String attributeName, @Nullable final Object attributeValue)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <p>{`You want to update `}<inlineCode parentName="p">{`username`}</inlineCode>{` of a user obtained in the log in page:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`UserProfile.updateUserAttribute("username", "Will Smith");
`}</code></pre>
    <Variant platform="android" api="update-user-attributes" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "java-6"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void updateUserAttributes(@NonNull final Map<String, Object> attributeMap)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <p>{`You want to update `}<inlineCode parentName="p">{`username`}</inlineCode>{`, `}<inlineCode parentName="p">{`usertype`}</inlineCode>{` of a user obtained in the log in page:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`HashMap<String, Object> profileMap = new HashMap<>();
profileMap.put("username","Will Smith");
profileMap.put("usertype","Actor");
UserProfile.updateUserAttributes(profileMap);
`}</code></pre>
    <h4 {...{
      "id": "kotlin-3"
    }}>{`Kotlin`}</h4>
    <p><strong parentName="p">{`Example`}</strong></p>
    <p>{`You want to update `}<inlineCode parentName="p">{`username`}</inlineCode>{`, `}<inlineCode parentName="p">{`usertype`}</inlineCode>{` of a user obtained in the log in page:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`val profileMap = mapOf(
        "username" to "Will Smith",
        "usertype" to "Actor"
    )
UserProfile.updateUserAttributes(profileMap)
`}</code></pre>
    <Variant platform="ios" api="update-user-attributes" repeat="11" mdxType="Variant" />
    <h4 {...{
      "id": "swift-4"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func updateUserAttributes(attributeDict: [String: Any])
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <p>{`You want to update `}<inlineCode parentName="p">{`username, usertype`}</inlineCode>{` of a user obtained in the log in page:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`var profileMap = [AnyHashable: Any]()
profileMap["username"] = "will_smith"
profileMap["usertype"] = "Actor"
UserProfile.updateUserAttributes(attributeDict: profileMap)
`}</code></pre>
    <h4 {...{
      "id": "objective-c-4"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (void)updateUserAttributesWithAttributeDict:(NSDictionary<NSString *,id> * _Nonnull)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`NSMutableDictionary *profileMap = [NSMutableDictionary dictionary];
[profileMap setObject:@"username" forKey:@"will_smith"];
[profileMap setObject:@"usertype" forKey:@"Actor"];
[AEPMobileUserProfile updateUserAttributesWithAttributeDict:profileMap];
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      